/**
 * Client-side topic categories store. Populated by
 * hydratePrototypeRuntime from /api/categories. The 4 markup files
 * that hardcode the 6 category buttons (browse / idea modal /
 * AI Create modal / profile interests) call hydrateCategoryButtons
 * once after bootstrap to replace the static <button> list.
 */

export interface TopicCategory {
  slug: string;
  label: string;
  description?: string | null;
}

let _categories: TopicCategory[] = [];
let _hydrated = false;

export const categoriesStore = {
  set(categories: TopicCategory[]): void {
    _categories = categories;
    _hydrated = true;
  },

  list(): TopicCategory[] {
    return _categories;
  },

  isHydrated(): boolean {
    return _hydrated;
  },

  label(slug: string): string {
    return _categories.find((c) => c.slug === slug)?.label ?? slug;
  },
};
